import React from 'react';
import ReportBox from "./ReportBox";

const ReportOldInventory = () => {
    return (
        <div>
            <ReportBox pageName="oldInventory" apiAddress="Pallet/OldInventoryReport" title="گزارش موجودی گذشته"/>

        </div>
    );
};

export default ReportOldInventory;